document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".custom_banner .customBannerSwiper", {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

    });
  });



 $(document).ready(function () {
    $('.add-to-cart-btn').on('click', function (e) {
      e.preventDefault(); 

       var variantId = $(this).closest('[action="/cart/add"]').find('input[name="id"]').val();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: variantId,
          quantity: 1
        },
        dataType: 'json',
        success: function (response) {
          console.log("Item added to cart:", response);
         document.dispatchEvent(new CustomEvent("cart:refresh"));
setTimeout(function() {
$('cart-dot.header__cart-dot.is-visible').click();
}, 500);


        },
        error: function (error) {
          console.error("Error adding to cart:", error);
        }
      });

        
    });

    
    
  });
  
  document.addEventListener("DOMContentLoaded", function () {
  const allQuestions = document.querySelectorAll(".faq-question");
  const allAnswers = document.querySelectorAll(".faq-answer");

  if (allQuestions.length > 0 && allAnswers.length > 0) {
    allQuestions[0].classList.add("active");
    allAnswers[0].classList.add("active");
    allQuestions[0].setAttribute("aria-expanded", "true");
  }

  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("faq-question")) {
      const clickedQuestion = e.target;
      const clickedAnswer = clickedQuestion.nextElementSibling;


      allQuestions.forEach((q, index) => {
        q.classList.remove("active");
        allAnswers[index].classList.remove("active");
        q.setAttribute("aria-expanded", "false");
      });

      
      clickedQuestion.classList.add("active");
      clickedAnswer.classList.add("active");
      clickedQuestion.setAttribute("aria-expanded", "true");
    }
  });
});

  
  





